import React, { useState } from 'react'
import styles from '../AdminPanelPage.module.scss'
import {
  createTopBaseBranch,
  createChppBranch,
  createPrivatePointBranch,
  updateBranch
} from 'service/AdminPanelService'

const CreateBranchForm = ({
  modalPayload,
  onClose,
  loadTopBases,
  loadChpps,
  loadPrivatePoints
}) => {
  const [formData, setFormData] = useState({
    name: modalPayload?.name || '',
    address: modalPayload?.address || '',
    geo: modalPayload?.geo || '',
    is_active: modalPayload?.is_active !== undefined ? modalPayload.is_active : true
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      const payload = { ...formData }
      if (modalPayload?.id) {
        // Update
        await updateBranch(modalPayload.id, payload)
      } else {
        // Create
        if (modalPayload?.top_base) {
          await createTopBaseBranch(modalPayload.top_base, payload)
          if (loadTopBases) loadTopBases()
        } else if (modalPayload?.chpp) {
          await createChppBranch(modalPayload.chpp, payload)
          if (loadChpps) loadChpps()
        } else if (modalPayload?.private_point) {
          await createPrivatePointBranch(modalPayload.private_point, payload)
          if (loadPrivatePoints) loadPrivatePoints()
        }
      }
      onClose()
    } catch (err) {
      setError('Ошибка сохранения филиала')
    } finally {
      setLoading(false)
    }
  }

  const baseName = modalPayload?.top_base_name || modalPayload?.chpp_name || modalPayload?.private_point_name || 'База'
  const baseLabel = modalPayload?.top_base ? 'ТОП-База' : modalPayload?.chpp ? 'ТЭЦ' : modalPayload?.private_point ? 'Частная точка' : 'База'

  return (
    <>
      <label>{baseLabel}</label>
      <input placeholder={baseLabel} value={baseName} readOnly />

      <label>Название филиала</label>
      <input
        placeholder="Название филиала"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        required
      />

      <label>Адрес</label>
      <input
        placeholder="Адрес"
        value={formData.address}
        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
      />

      <label>Гео (lat,lng)</label>
      <input
        placeholder="41.123,74.456"
        value={formData.geo}
        onChange={(e) => setFormData({ ...formData, geo: e.target.value })}
      />

      <label>
        <input
          type="checkbox"
          checked={formData.is_active}
          onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
        />
        Активен
      </label>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
        <button onClick={onClose} className={styles.btn_pin_close}>Отмена</button>
        <button onClick={handleSubmit} disabled={loading} className={styles.btn_pin}>
          {loading ? 'Сохранение...' : modalPayload?.id ? 'Сохранить' : 'Создать'}
        </button>
      </div>
    </>
  )
}

export default CreateBranchForm